import { render, staticRenderFns } from "./edit-form-control.vue?vue&type=template&id=61d7401f&scoped=true&"
import script from "./edit-form-control.vue?vue&type=script&lang=js&"
export * from "./edit-form-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d7401f",
  null
  
)

export default component.exports